import React from "react";
import LoginContainer from "../components/Home/LoginContainer";

type Props = {};

const Home = (props: Props) => {
  return (
    <div className="page">
      <LoginContainer />
    </div>
  );
};

export default Home;
